<template>
  <section class="calendar">
    <div class="calendar-box pbm">
      <header class="calendar-box__hd fs4">
        <div class="calendar-box__hd_btn" @click="PreMonth(myDate,false)">
          <van-icon name="arrow-left" />
        </div>
       
        <div class="calendar-box__hd_topdate">{{dateTop}}</div>
        <div class="calendar-box__hd_btn" @click="NextMonth(myDate,false)">
          <van-icon name="arrow" />
        </div>
      </header>
      <div class="calendar-box__content mbm">
        <div class="calendar-box__content_item" v-for="(tag,key) in textTop" v-bind:key="key">
          <div class="calendar-box__content_tag">{{tag}}</div>
        </div>
      </div>
      <v-touch v-on:swipeleft="NextMonth(myDate,false)" v-on:swiperight="PreMonth(myDate,false)">
      <div class="calendar-box__content" :class="brandFold == true ? 'date':''">
        <div class="calendar-box__content_item" v-for="(item,index) in list" @click="clickDay(item,index)" v-bind:key="index">
          <div class="calendar-box__content_date" v-bind:class="[{ wh_isMark: item.isMark},{wh_other_dayhide:item.otherMonth!=='nowMonth'},{wh_want_dayhide:item.dayHide},{wh_isToday:item.isToday},{wh_chose_day:item.chooseDay},setClass(item)]">
            {{item.id}}
          </div>
        </div>
      </div>
      </v-touch>
      <div class="tac crw mtn fs2 setBtn" @click="changeFoldState">
        <span>{{brandFold?'展开':'收起'}}</span>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue';
import { Icon } from 'vant';
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(Icon);
import timeUtil from '@/components/calendar-component/calendar';

export default {
  data() {
    return {
      textTop: ['一', '二', '三', '四', '五', '六', '日'],
      myDate: [],
      list: [],
      historyChose: [],
      dateTop: '',
      brandFold: true,  //展开 收起  Tina 2018年9月29日17:08:30
    };
  },
  props: {
    markDate: {
      type: Array,
      default: () => []
    },
    markDateMore: {
      type: Array,
      default: () => []
    },
    sundayStart: {
      type: Boolean,
      default: () => false
    },
    agoDayHide: { type: String, default: `0` },
    futureDayHide: { type: String, default: `2554387200` }
  },
  created() {
    this.intStart();
    this.myDate = new Date();
  },
  methods: {
    intStart() {
      if (this.sundayStart) {
        this.textTop = ['日', '一', '二', '三', '四', '五', '六'];
      } else {
        this.textTop = ['一', '二', '三', '四', '五', '六', '日'];
      }
      timeUtil.sundayStart = this.sundayStart;
    },
    setClass(data) {
      let obj = {};
      obj[data.markClassName] = data.markClassName;
      return obj;
    },
    clickDay: function (item, index) {
      if (item.otherMonth === 'nowMonth' && !item.dayHide) {
        this.getList(this.myDate, item.date);
      }
      if (item.otherMonth !== 'nowMonth') {
        item.otherMonth === 'preMonth'
          ? this.PreMonth(item.date)
          : this.NextMonth(item.date);
      }
    },
    ChoseMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = new Date(date);
      this.$emit('changeMonth', timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    PreMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, 'preMonth');
      this.$emit('changeMonth', timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    NextMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, 'nextMonth');
      this.$emit('changeMonth', timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    forMatArgs: function () {
      let markDate = this.markDate;
      let markDateMore = this.markDateMore;
      markDate = markDate.map((k) => {
        return timeUtil.dateFormat(k);
      })
      markDateMore = markDateMore.map((k) => {
        k.date = timeUtil.dateFormat(k.date)
        return k;
      })
      return [markDate, markDateMore];
    },
    getList: function (date, chooseDay, isChosedDay = true) {
      const [markDate, markDateMore] = this.forMatArgs();
      this.dateTop = `${date.getFullYear()}年${date.getMonth() + 1}月`;
      let arr = timeUtil.getMonthList(this.myDate);
      for (let i = 0; i < arr.length; i++) {
        let markClassName = '';
        let k = arr[i];
        k.chooseDay = false;
        const nowTime = k.date;
        const t = new Date(nowTime).getTime() / 1000;
        //看每一天的class
        for (const c of markDateMore) {
          if (c.date === nowTime) {
            markClassName = c.className || '';
          }
        }
        //标记选中某些天 设置class
        k.markClassName = markClassName;
        k.isMark = markDate.indexOf(nowTime) > -1;
        //无法选中某天
        k.dayHide = t < this.agoDayHide || t > this.futureDayHide;
        if (k.isToday) {
          this.$emit('isToday', nowTime);
        }
        let flag = !k.dayHide && k.otherMonth === 'nowMonth';
        if (chooseDay && chooseDay === nowTime && flag) {
          this.$emit('choseDay', nowTime);
          this.historyChose.push(nowTime);
          k.chooseDay = true;
        } else if (
          this.historyChose[this.historyChose.length - 1] === nowTime && !chooseDay && flag
        ) {
          k.chooseDay = true;
        }
      }
      this.list = arr;
    },
    changeFoldState() {
      //展开 收起  Tina 2018年9月29日17:08:30
      this.brandFold = !this.brandFold
    }
  },
  mounted() {
    this.getList(this.myDate);
  },
  watch: {
    markDate(val, oldVal) {
      this.getList(this.myDate);
    },
    markDateMore(val, oldVal) {
      this.getList(this.myDate);
    },
    agoDayHide(val, oldVal) {
      this.agoDayHide = parseInt(val);
      this.getList(this.myDate);
    },
    futureDayHide(val, oldVal) {
      this.futureDayHide = parseInt(val);
      this.getList(this.myDate);
    },
    sundayStart(val, oldVal) {
      this.intStart();
      this.getList(this.myDate);
    }
  }
};
</script>

<style lang="less" scoped>
.calendar {
  margin: auto;
  &-box {
    background-color: #68c864;
    width: 100%;
    overflow: hidden;
    &__hd {
      display: flex;
      &>div{
        cursor: pointer;
        display: flex;
        color: #fff;
        justify-content: center;
        align-items: center;
        height: .5rem;
      }
      &_btn{
        flex: 1;
      }
      &_topdate{
        cursor: auto;
        flex: 4;
      }
    }
    &__content {
      display: flex;
      flex-wrap: wrap;
      padding: 0 .15rem;
      width: 100%;
      &_date {
        color: #fff;
        width: .4rem;
        height: .4rem;
        line-height: .4rem;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &:first-child>&_item>&_item_tag,
      &:first-child>&_item {
        color: #ddd;
        font-size: .16;
      }
      &_item,&_item_tag {
        font-size: .16rem;
        width: 14.2857143%;
        text-align: center;
        color: #fff;
        position: relative;
      }
      &_item {
        line-height: .4rem;
        &> .wh_isMark {
          margin: auto;
          border-radius: 100px;
          background:#82d67f;
          color:white;
          z-index: 2;
          &::after{
            content:'.';
            // color: #fff;
            position: absolute;
            bottom:0;
            left: 50%;
            font-size: 0.4rem;
            transform: translate(-50%,0);
            -moz-transform: translate(-50%,0);
            -ms-transform: translate(-50%,0);
            -webkit-transform: translate(-50%,0);
            -o-transform: translate(-50%,0);
          }
        }
        &>.wh_chose_day {
          background:#58AA55;
          // background:#82d67f;
          border-radius: 100px;
        }
        &>.wh_other_dayhide,
        &>.wh_want_dayhide{
          color: #98DA96;
        }
        &>.wh_isToday {
          background: yellow;
          color: #68c864;
          border-radius: 100px;
          // &::after{
          //   content:'今';
          //   color: #fff;
          //   position: absolute;
          //   bottom:0;
          //   left: 50%;
          //   // font-size: 0.4rem;
          //   transform: translate(-50%,0);
          //   -moz-transform: translate(-50%,0);
          //   -ms-transform: translate(-50%,0);
          //   -webkit-transform: translate(-50%,0);
          //   -o-transform: translate(-50%,0);
          // }
        }
      }
    }
    &__content.date {
      height: 80px;
      overflow-y: auto;
    }
  }
  // .setBtn{
  //   text-align: center;
  //   color: #fff;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/calendar-component/calendar.vue